// src/pages/Main/Steps/Steps.tsx
import s from './Steps.module.scss'
import React from 'react'
import { useLanguage } from 'context/LanguageContext'
import { translations } from './translations'

const Steps: React.FC = React.memo(() => {
    const { language } = useLanguage()
    const { title, subtitle, steps } = translations[language]

    return (
        <div className={s.wrapper}>
            <h2 className={s.title}>{title}</h2>
            <p className={s.subtitle}>{subtitle}</p>

            <ol className={s.steps}>
                {steps.map((step, i) => (
                    <li className={s.step} key={i}>
                        <span className={s.number} aria-hidden="true">
                            {i + 1}
                        </span>
                        <h3 className={s.stepTitle}>{step.title}</h3>
                        <p className={s.stepDesc}>{step.desc}</p>
                    </li>
                ))}
            </ol>
        </div>
    )
})

export default Steps
